import Reflux from "reflux";

export const ActionsCampaignsOverview = Reflux.createActions({
  getActiveCampaignCount: { asyncResult: true },
  getActiveApplicantsCount: { asyncResult: true },
  getHelloMessage: { asyncResult: true }
});
